
import Cake from "../../../assets/outline/Cake.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CakeIcon({ className, dataTestid = "CakeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Cake data-testid={dataTestid} className={classes} {...rest} />
  );
}
